import { gql } from '@apollo/client'
import { PICOS_COMPLIANCE_CRITERIA_FRAGMENT } from '../fragments'

export const GET_PICOS_COMPLIANCE_CRITERIA = gql`
  query PicOSProductComplianceCriteria(
    $input: PicOSProductComplianceCriteriaInput!
  ) {
    picosProductComplianceCriteria(input: $input) {
      ...PicOSProductComplianceCriteria
    }
  }
  ${PICOS_COMPLIANCE_CRITERIA_FRAGMENT}
`
